import { render, staticRenderFns } from "./scoresOnly.vue?vue&type=template&id=6f79696b&scoped=true"
import script from "./scoresOnly.vue?vue&type=script&lang=js"
export * from "./scoresOnly.vue?vue&type=script&lang=js"
import style0 from "./scoresOnly.vue?vue&type=style&index=0&id=6f79696b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f79696b",
  null
  
)

export default component.exports